<div class="row mb-3">
    <label class="col-2 col-form-label text-start" translate="CONFIRMATION_ATTENDEELIST_TITLE_LABEL"></label>
    <label class="col-2 col-form-label text-start" translate="CONFIRMATION_ATTENDEELIST_FIRSTNAME_LABEL"></label>
    <label class="col-2 col-form-label text-start" translate="CONFIRMATION_ATTENDEELIST_LASTNAME_LABEL"></label>
    <label class="col-2 col-form-label text-start" translate="CONFIRMATION_ATTENDEELIST_EMAIL_LABEL"></label>
    <label class="col-2 col-form-label text-start" translate="CONFIRMATION_ATTENDEELIST_NON_CREDIT_LABEL"></label>
</div>
<div class="text-center" *ngIf="model.attendeeList.value.length === 0">
    <span translate="CONFIRMATION_ATTENDEELIST_LIST_ATTENDEE_NOT_AVAILABLE"></span>
</div>
<div [formGroup]="attendeesForm">
    <fieldset>
        <div class="row mb-3" *ngFor="let attendee of model.attendeeList.value; index as i">
            <div class="col-2">{{ attendee.getDisplayTitle() }}</div>
            <div class="col-2">{{ attendee.firstName.value }}</div>
            <div class="col-2">{{ attendee.lastName.value }}</div>
            <div class="col-2">{{ attendee.mail.value }}</div>
            <div class="col-2">{{ attendee.getDisplayNotReceivingCredit() }}</div>
            <div class="col-2">
                <button
                    type="button"
                    class="btn btn-secondary me-1"
                    (click)="editAttendee(i)"
                    [disabled]="attendee.formSubmitted || (formSubmitted$ | async)"
                    [attr.aria-label]="('CONFIRMATION_ATTENDEELIST_EDIT_ATTENDEE_ARIA_LABEL' | translate) + (i + 1)"
                >
                    <fa-icon [icon]="faPencil"></fa-icon>
                </button>
                <button
                    type="button"
                    class="btn btn-warning"
                    (click)="deleteAttendee(i)"
                    [attr.aria-label]="('CONFIRMATION_ATTENDEELIST_DELETE_ATTENDEE_ARIA_LABEL' | translate) + (i + 1)"
                    [disabled]="attendee.formSubmitted || (formSubmitted$ | async)"
                >
                    &times;
                </button>
            </div>
        </div>
    </fieldset>
</div>
<hr class="separator" />
<div class="row">
    <div class="col-12 d-flex">
        <button
            class="btn btn-primary ms-auto"
            (click)="addAttendee()"
            [disabled]="formSubmitted$ | async"
            translate="CONFIRMATION_ATTENDEELIST_ADD_ATTENDEE_LABEL"
        ></button>
    </div>
</div>
